import { render, staticRenderFns } from "./FormEmployeeEnderecos.vue?vue&type=template&id=b0d54fd8"
import script from "./FormEmployeeEnderecos.vue?vue&type=script&lang=js"
export * from "./FormEmployeeEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormEmployeeEnderecos.vue?vue&type=style&index=0&id=b0d54fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports